import type { FormFields } from '../../models/newSupportCall';
import { F2_FORM_SUBJECTS } from '../support/constants';

export type RequiredFieldRule = {
    field: keyof FormFields;
    message: string;
};

const tasCommonRequiredFields: RequiredFieldRule[] = [
    { field: 'partOrComponentName', message: 'Nome da Peça ou Componente é obrigatório' },
    { field: 'partNumber', message: 'Nº da peça VW/MAN é obrigatório' },
];

const customerCommentRule: RequiredFieldRule = {
    field: 'customerComment',
    message: 'Qual a reclamação do cliente? é obrigatório',
};

const problemDescriptionRule: RequiredFieldRule = {
    field: 'problemDescription',
    message: 'O que aconteceu? é obrigatório',
};

const diagnosticAndResultsRule: RequiredFieldRule = {
    field: 'diagnosticAndResults',
    message: 'Relate procedimentos de diagnóstico e resultados é obrigatório',
};

const problemStepsRule: RequiredFieldRule = {
    field: 'problemSteps',
    message: 'É possível reproduzir? Informe o passo-a-passo é obrigatório',
};

export const getTasAdditionalRequiredFields = (subject: string): RequiredFieldRule[] => {
    if (F2_FORM_SUBJECTS.includes(subject)) {
        return [
            ...tasCommonRequiredFields,
            customerCommentRule,
            problemStepsRule,
            diagnosticAndResultsRule,
        ];
    }

    if (subject === 'CABIN') {
        return [
            ...tasCommonRequiredFields,
            customerCommentRule,
            problemDescriptionRule,
            diagnosticAndResultsRule,
        ];
    }

    if (subject === 'EXHAUST_SYSTEM_AND_AFTER_TREATMENT') {
        return [
            ...tasCommonRequiredFields,
            customerCommentRule,
            diagnosticAndResultsRule,
        ];
    }

    if (subject === 'SOFTWARE_DIESEL_VEHICLE') {
        return [
            ...tasCommonRequiredFields,
            customerCommentRule,
            { field: 'failureFrequency', message: 'Em qual frequência a falha ocorre? é obrigatório' },
            problemStepsRule,
            diagnosticAndResultsRule,
        ];
    }

    if (subject === 'ENGINE_REPLACEMENT_REQUEST' || subject === 'TAS_DIAGNOSIS_TOOLS') {
        return [
            ...tasCommonRequiredFields,
            problemDescriptionRule,
            diagnosticAndResultsRule,
        ];
    }

    if (subject === 'SOFTWARE_IDLE_AUTO_SHUTDOWN') {
        return [
            ...tasCommonRequiredFields,
            customerCommentRule,
        ];
    }

    return [];
};
